export default "__VITE_ASSET__d9cb4716__"